import { fork, takeEvery, takeLatest } from "redux-saga/effects";

import GoogleConstants from "modules/google/constants";
import GoogleSagas from "modules/google/sagas";
import GoogleActions from "modules/google/actions";

function* watchShowNoAdsToast() {
  yield takeLatest(GoogleConstants.SHOW_NO_ADS_TOAST, GoogleSagas.showNoAdsToast);
}

function* watchSetGoogleUserInfo() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_USER_INFO, GoogleSagas.setGoogleUserInfo);
}

function* watchSetSyncedOfflineConversions() {
  yield takeLatest(GoogleConstants.SET_SYNCED_OFFLINE_CONVERSIONS, GoogleSagas.setSyncedOfflineConversions);
}

function* watchChangeSettingPage() {
  yield takeLatest(GoogleConstants.CHANGE_SETTING_PAGE, GoogleSagas.changeSettingPage);
}

function* watchGetAccountHierarchy() {
  yield takeEvery(GoogleConstants.GET_ACCOUNT_HIERARCHY, GoogleSagas.getAccountHierarchy);
}

function* watchGetBusinessInfo() {
  yield takeEvery(GoogleConstants.GET_BUSINESS_INFO, GoogleSagas.getBusinessInfo);
}

function* watchGetGoogleUserInfo() {
  yield takeEvery(GoogleActions.getGoogleUserInfo, GoogleSagas.getGoogleUserInfo);
}

function* watchAutoLinkAccount() {
  yield takeEvery(GoogleActions.autoLinkAccount, GoogleSagas.autoLinkAccount);
}

function* watchSetBusinessAdwordsId() {
  yield takeEvery(GoogleActions.setBusinessAdwordsId, GoogleSagas.setBusinessAdwordsId);
}

function* watchSetBusinessAdwordsName() {
  yield takeEvery(GoogleActions.setBusinessAdwordsName, GoogleSagas.setBusinessAdwordsName);
}

function* watchSetBusinessCanAccess() {
  yield takeEvery(GoogleActions.setBusinessCanAccess, GoogleSagas.setBusinessCanAccess);
}

function* watchGetAdwordsConversionsData() {
  yield takeEvery(GoogleActions.getAdwordsConversionsData, GoogleSagas.getAdwordsConversionsData);
}

function* watchGetAdwordsConversionsLastsend() {
  yield takeEvery(GoogleActions.getAdwordsConversionsLastsend, GoogleSagas.getAdwordsConversionsLastsend);
}

function* watchCreateOfflineConversion() {
  yield takeEvery(GoogleActions.createOfflineConversion, GoogleSagas.createOfflineConversion);
}

function* watchGetLinkAccountStatus() {
  yield takeEvery(GoogleActions.getLinkAccountStatus, GoogleSagas.getLinkAccountStatus);
}

function* watchGetBusinessPipelines() {
  yield takeEvery(GoogleActions.getBusinessPipelines, GoogleSagas.getBusinessPipelines);
}

function* watchGetBusinessSteps() {
  yield takeEvery(GoogleActions.getBusinessSteps, GoogleSagas.getBusinessSteps);
}

function* watchGetLeadSteps() {
  yield takeEvery(GoogleActions.getLeadSteps, GoogleSagas.getLeadSteps);
}

function* watchGetAdwordsPipelineConversionsData() {
  yield takeEvery(GoogleActions.getAdwordsPipelineConversionsData, GoogleSagas.getAdwordsPipelineConversionsData);
}

function* watchCreateAdwordsPipelineConversionsData() {
  yield takeEvery(GoogleActions.createAdwordsPipelineConversionsData, GoogleSagas.createAdwordsPipelineConversionsData);
}

function* watchGetOfflineConversionAddon() {
  yield takeEvery(GoogleActions.getOfflineConversionAddon, GoogleSagas.getOfflineConversionAddon);
}

function* watchUpdateOfflineConversionAddon() {
  yield takeEvery(GoogleActions.updateOfflineConversionAddon, GoogleSagas.updateOfflineConversionAddon);
}

function* watchGetAccountData() {
  yield takeEvery(GoogleActions.getAccountData, GoogleSagas.getAccountData);
}

//function* watchRwidgetConversionDefaultValue() {
//  yield takeEvery(GoogleActions.rwidgetConversionDefaultValue, GoogleSagas.rwidgetConversionDefaultValue)
//}

function* watchRwidgetConversionDefaultValue() {
  yield takeEvery(GoogleConstants.SET_RWIDGET_CONVERSION_DEFAULT_VALUE, GoogleSagas.setRwidgetConversionDefaultValue);
}

function* watchGetGoogleSheetsList() {
  yield takeEvery(GoogleActions.getGoogleSheetsList, GoogleSagas.getGoogleSheetsList);
}

function* watchGetGoogleExchangeToken() {
  yield takeEvery(GoogleActions.getGoogleExchangeToken, GoogleSagas.getGoogleExchangeToken);
}

function* watchSetGoogleAccount() {
  yield takeEvery(GoogleActions.setGoogleAccount, GoogleSagas.setGoogleAccount);
}

function* watchGetGoogleAccount() {
  yield takeEvery(GoogleActions.getGoogleAccount, GoogleSagas.getGoogleAccount);
}

function* watchSetGoogleSheetsSetting() {
  yield takeEvery(GoogleActions.setGoogleSheetsSetting, GoogleSagas.setGoogleSheetsSetting);
}

function* watchGetGoogleAdsLeadForm() {
  yield takeEvery(GoogleActions.getGoogleAdsLeadForm, GoogleSagas.getGoogleAdsLeadForm);
}

function* watchChangeGoogleAdsFormSelectType() {
  yield takeLatest(GoogleConstants.CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE, GoogleSagas.changeGoogleAdsFormSelectType);
}

function* watchSetCheckedGoogleAdsFormItems() {
  yield takeLatest(GoogleConstants.SET_CHECKED_GOOGLE_ADS_FORM_ITEMS, GoogleSagas.setCheckedGoogleAdsFormItems);
}

function* watchSetGoogleLeadGoogleConnected() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_LEAD_GOOGLE_CONNECTED, GoogleSagas.setGoogleLeadGoogleConnected);
}

function* watchSetGoogleLeadGoogleDisconnected() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED, GoogleSagas.setGoogleLeadGoogleDisconnected);
}

function* watchChangeGoogleLeadSheetsUrlInput() {
  yield takeLatest(GoogleConstants.CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT, GoogleSagas.changeGoogleLeadSheetsUrlInput);
}

function* watchSetGoogleAdsLeadFormSetting() {
  yield takeEvery(GoogleActions.setGoogleAdsLeadFormSetting, GoogleSagas.setGoogleAdsLeadFormSetting);
}

function* watchSetGoogleSheetsGGLeadsSetting() {
  yield takeEvery(GoogleActions.setGoogleSheetsGGLeadsSetting, GoogleSagas.setGoogleSheetsGGLeadsSetting);
}

function* watchGetAllGoogleLeadFormSettings() {
  yield takeEvery(GoogleActions.getAllGoogleLeadFormSettings, GoogleSagas.getAllGoogleLeadFormSettings);
}

function* watchSwitchGoogleLeadFormStatus() {
  yield takeEvery(GoogleActions.switchGoogleLeadFormStatus, GoogleSagas.switchGoogleLeadFormStatus);
}

function* watchArchiveGoogleLeadFormSetting() {
  yield takeEvery(GoogleActions.archiveGoogleLeadFormSetting, GoogleSagas.archiveGoogleLeadFormSetting);
}

function* watchGetGoogleAdsSetting() {
  yield takeEvery(GoogleActions.getGoogleAdsSetting, GoogleSagas.getGoogleAdsSetting);
}

function* watchGetGoogleSheetsSetting() {
  yield takeEvery(GoogleActions.getGoogleSheetsSetting, GoogleSagas.getGoogleSheetsSetting);
}

function* watchGetGoogleLeadCRMSetting() {
  yield takeEvery(GoogleActions.getGoogleLeadCRMSetting, GoogleSagas.getGoogleLeadCRMSetting);
}

function* watchGetGoogleLeadFormSetting() {
  yield takeEvery(GoogleActions.getGoogleLeadFormSetting, GoogleSagas.getGoogleLeadFormSetting);
}

function* watchSetValidateGoogleLeadForm() {
  yield takeLatest(GoogleConstants.SET_VALIDATE_GOOGLE_LEAD_FORM, GoogleSagas.setValidateGoogleLeadForm);
}

function* watchSetValidateGoogleSheetsUrl() {
  yield takeLatest(GoogleConstants.SET_VALIDATE_GOOGLE_SHEETS_URL, GoogleSagas.setValidateGoogleSheetsUrl);
}

function* watchSetValidateGGLeadsGoogleSheetsUrl() {
  yield takeLatest(
    GoogleConstants.SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL,
    GoogleSagas.setValidateGGLeadsGoogleSheetsUrl,
  );
}

function* watchSetDuplicateGoogleForm() {
  yield takeLatest(GoogleConstants.SET_DUPLICATE_GOOGLE_FORM, GoogleSagas.setDuplicateGoogleForm);
}

function* watchGetGoogleSheetsOfflineConversionsValue() {
  yield takeEvery(
    GoogleActions.getGoogleSheetsOfflineConversionsValue,
    GoogleSagas.getGoogleSheetsOfflineConversionsValue,
  );
}

function* watchSetGoogleSheetsOfflineConversionsValue() {
  yield takeEvery(
    GoogleActions.setGoogleSheetsOfflineConversionsValue,
    GoogleSagas.setGoogleSheetsOfflineConversionsValue,
  );
}

function* watchGetGoogleSheetsOfflineConversionsLastSent() {
  yield takeEvery(
    GoogleActions.getGoogleSheetsOfflineConversionsLastSent,
    GoogleSagas.getGoogleSheetsOfflineConversionsLastSent,
  );
}

function* watchUpdateGGLeadFormSettingErrorStatus() {
  yield takeEvery(GoogleActions.updateGGLeadFormSettingErrorStatus, GoogleSagas.updateGGLeadFormSettingErrorStatus);
}

function* watchSetFileInfoError() {
  yield takeLatest(GoogleConstants.SET_FILE_INFO_ERROR, GoogleSagas.setFileInfoError);
}

function* watchSetGoogleLoading() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_LOADING, GoogleSagas.setGoogleLoading);
}

function* watchSetGoogleSheetsLoading() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_SHEETS_LOADING, GoogleSagas.setGoogleSheetsLoading);
}

function* watchSetGoogleSheetsError() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_SHEETS_ERROR, GoogleSagas.setGoogleSheetsError);
}

function* watchSetGoogleAdsLoading() {
  yield takeLatest(GoogleConstants.SET_GOOGLE_ADS_LOADING, GoogleSagas.setGoogleAdsLoading);
}

function* watchSetGGConnectionLoading() {
  yield takeLatest(GoogleConstants.SET_GG_CONNECTION_LOADING, GoogleSagas.setGGConnectionLoading);
}

export default [
  fork(watchShowNoAdsToast),
  fork(watchSetGoogleUserInfo),
  fork(watchSetSyncedOfflineConversions),
  fork(watchGetAccountHierarchy),
  fork(watchAutoLinkAccount),
  fork(watchGetBusinessInfo),
  fork(watchChangeSettingPage),
  fork(watchSetBusinessAdwordsId),
  fork(watchSetBusinessAdwordsName),
  fork(watchSetBusinessCanAccess),
  fork(watchGetAdwordsConversionsData),
  fork(watchCreateOfflineConversion),
  fork(watchGetLinkAccountStatus),
  fork(watchGetAccountData),
  fork(watchGetBusinessPipelines),
  fork(watchGetBusinessSteps),
  fork(watchGetAdwordsConversionsLastsend),
  fork(watchGetGoogleUserInfo),
  fork(watchGetAdwordsPipelineConversionsData),
  fork(watchGetOfflineConversionAddon),
  fork(watchUpdateOfflineConversionAddon),
  fork(watchCreateAdwordsPipelineConversionsData),
  fork(watchRwidgetConversionDefaultValue),
  fork(watchGetGoogleSheetsList),
  fork(watchGetGoogleExchangeToken),
  fork(watchSetGoogleAccount),
  fork(watchGetGoogleAccount),
  fork(watchSetGoogleSheetsSetting),
  fork(watchGetGoogleAdsLeadForm),
  fork(watchChangeGoogleAdsFormSelectType),
  fork(watchSetCheckedGoogleAdsFormItems),
  fork(watchSetGoogleLeadGoogleConnected),
  fork(watchSetGoogleLeadGoogleDisconnected),
  fork(watchChangeGoogleLeadSheetsUrlInput),
  fork(watchSetGoogleAdsLeadFormSetting),
  fork(watchSetGoogleSheetsGGLeadsSetting),
  fork(watchGetAllGoogleLeadFormSettings),
  fork(watchSwitchGoogleLeadFormStatus),
  fork(watchArchiveGoogleLeadFormSetting),
  fork(watchGetGoogleAdsSetting),
  fork(watchGetGoogleSheetsSetting),
  fork(watchGetGoogleLeadCRMSetting),
  fork(watchGetGoogleLeadFormSetting),
  fork(watchSetValidateGoogleLeadForm),
  fork(watchSetValidateGoogleSheetsUrl),
  fork(watchSetValidateGGLeadsGoogleSheetsUrl),
  fork(watchSetDuplicateGoogleForm),
  fork(watchGetLeadSteps),
  fork(watchGetGoogleSheetsOfflineConversionsValue),
  fork(watchSetGoogleSheetsOfflineConversionsValue),
  fork(watchGetGoogleSheetsOfflineConversionsLastSent),
  fork(watchUpdateGGLeadFormSettingErrorStatus),
  fork(watchSetFileInfoError),
  fork(watchSetGoogleLoading),
  fork(watchSetGoogleSheetsLoading),
  fork(watchSetGoogleSheetsError),
  fork(watchSetGoogleAdsLoading),
  fork(watchSetGGConnectionLoading),
];
